import config from '../config';

export interface EmailApiClientOptions {
  correlationId?: string;
}

export const createEmailApiClient = () => {
  return (path: string, init?: RequestInit, options?: EmailApiClientOptions): Promise<Response> => {
    const baseUrl = config.emailApiUrl;

    if (!baseUrl) {
      throw new Error('Email API Url is not configured');
    }

    const correlationId = options?.correlationId ?? crypto.randomUUID();
    const attemptId = crypto.randomUUID();

    const headers = new Headers(init?.headers);
    headers.set('Coolblue-CorrelationId', correlationId);
    headers.set('Coolblue-AttemptId', attemptId);

    return fetch(`${baseUrl}${path}`, {
      ...init,
      headers
    });
  };
};

export const emailApiClient = createEmailApiClient();
